export default [
  {
    name: 'Mężczyzna',
    value: 'MALE'
  },
  {
    name: 'Kobieta',
    value: 'FEMALE'
  }
];
